export const getInitialsName = (
  first_name: string | null,
  last_name: string | null
): string => {
  const firstInitial = (first_name || 'N').trim().charAt(0)
  const lastWords = (last_name || 'A').trim().split(/\s+/)
  const lastInitial = lastWords[lastWords.length - 1].charAt(0)

  return (firstInitial + lastInitial).toUpperCase()
}
